<template>
  <div>
    <v-container>
      <div class="bg-secondary text border pt-2 pb-2">
        <div class="d-flex justify-content-between">
          <v-btn @click="hideChart()" class="ma-2" outlined color="white">
            Back
          </v-btn>
          <v-btn class="ma-2" outlined color="white">
            {{ itemHistory.itemName }}
          </v-btn>
        </div>
        <div class="d-flex justify-content-end">
          <v-btn class="ma-2" outlined color="white">
            {{ worldSelected }}
          </v-btn>
        </div>
        <div class="d-flex justify-content-center">
          <v-btn @click="updateChart(0)" class="ma-2" outlined color="white">
            7 days
          </v-btn>
          <v-btn @click="updateChart(1)" class="ma-2" outlined color="white">
            30 days
          </v-btn>
          <v-btn @click="updateChart(2)" class="ma-2" outlined color="white">
            90 days
          </v-btn>
          <v-btn @click="updateChart(3)" class="ma-2" outlined color="white">
            180 days
          </v-btn>
        </div>

        <div class="example">
          <button
            id="back"
            @click="clicked()"
            style="float: right; margin-right: 2%; visibility: hidden"
          >
            Back
          </button>
          <apexcharts
            id="chart"
            type="line"
            ref="chart2"
            :options="chartOptions"
            :series="series"
          ></apexcharts>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { mapMutations, mapState } from "vuex";
export default {
  name: "Chart",
  components: {
    apexcharts: VueApexCharts,
  },

  data: function () {
    return {
      chartOptions: {
        legend: {
          show: false,
        },
        chart: {
          id: "basic-bar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            dataLabels: {
              enabled: true,
              position: "top",
            },
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#ffffff",
            shadeIntensity: 0,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "price GP",
          data: [],
        },
      ],
    };
  },

  created() {
    this.basechart();
  },
  computed: {
    ...mapState(["itemHistory", "worldSelected"]),
  },
  watch: {
    itemHistory: {
      handler: function () {
        this.basechart(); // call it in the context of your component object
      },
    },
  },
  methods: {
    ...mapMutations(["hideChart", "getHistory"]),
    async updateChart(timeSpan) {
      this.getHistory({
        itemName: this.itemHistory.itemName,
        time: timeSpan,
        world: this.worldSelected,
      });
    },
    clicked() {
      this.basechart();
    },
    basechart() {
      try {
        var x = this.itemHistory.categories;
        var y = this.itemHistory.prices;
        this.chartOptions = {
          xaxis: {
            categories: x,
          },
        };
        this.series = [
          {
            data: y,
          },
        ];
        //console.log(this.chartOptions.xaxis.categories);
        this.$refs.chart2.updateSeries(this.series, true);
        this.$refs.chart2.updateOptions(this.chartOptions, false, true);

        document.getElementById("back").style["visibility"] = "hidden";

        this.$apexcharts.exec("basic-bar", "updateSeries", this.series);
      } catch (err) {
        this.error = err.message;
      }
    },
    drilldown1() {
      try {
        var x = [1, 2, 3, 4, 5];
        var y = [30, 40, 45, 50, 49];

        //document.getElementById("chart").setAttribute('type','line');

        //this.$refs.chart2.updateOptions(this.chartOptions2,false,true);
        this.chartOptions2 = {
          xaxis: {
            categories: x,
          },
        };
        this.series2 = [
          {
            data: y,
          },
        ];
        console.log(this.chartOptions.xaxis.categories);
        this.$refs.chart2.updateSeries(this.series2, true);
        this.$refs.chart2.updateOptions(this.chartOptions2, false, true);
        document.getElementById("back").style["visibility"] = "visible";
      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>


<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: "black";
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}

.hoverable {
  border-radius: 10px;
}

.hoverable:hover {
  cursor: pointer;
  border-radius: 10px;
  background-color: rgb(60, 60, 60);
}
</style>